import type { McpServerSpec } from "@p0security/shared/types/agentic/mcp";

import type { McpServerSpecResolver } from "./types.ts";

export const newToolFilterOAuthMcp =
  (
    args: Pick<
      McpServerSpec & { type: "external" },
      "iconUrl" | "instance" | "label" | "url"
    >
  ): McpServerSpecResolver =>
  (location) => {
    const prefixArgs = ["agentic", "tool", location.gateway, location.server];
    return {
      ...args,
      type: "external",
      // The gateway fills in the tool list from the upstream server
      tools: { type: "manual", tools: [] },
      credential: {
        type: "oauth",
        grant: { type: "authorization_code" },
      },
      access: {
        prompt: `Request access to ${args.label} by calling with argv:

  [<tool>..., "--reason", <reason>]

where:

  - tool: One or more tools you intend to call
  - reason: The reason access is needed
`,
        prefixArgs,
      },
      authorization: "tool",
      list: {
        fields: {
          tool: {
            description: "Tools",
            required: [],
          },
        },
        prefixArgs,
      },
    };
  };
